import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Lynnwood from '../../components/Lynnwood/Lynnwood'

const Lynnwoodpage = () => {
    return (
        <div>
        <Navbar/>
        <Lynnwood/>



        <Footer/>

        </div>
    )
}

export default Lynnwoodpage